import React from "react";
const NoDataFound = () => {

    return (
        <tbody className="">
        <tr>
            <td colSpan={10}>
                <div className="headless_empty_row">
                    <div className="headless_empty_row_title">
                        We're sorry, we couldn't find exact matches for your filters.
                    </div>

                </div>
            </td>
        </tr>
        </tbody>
    );
};

export default NoDataFound;
